import Swiper from 'swiper';
import SwiperCore, { Pagination } from 'swiper/core';

export default () => {
    const sliderContainer = document.querySelector('.opinionSwiper');
    if (sliderContainer) {
        SwiperCore.use([Pagination]);
        new Swiper(sliderContainer, {
            loop: true,
            allowTouchMove: true,
            speed: 1500,
            pagination: {
                clickable: true,
                el: '.opinionSwiper-pagination',
            },
            // threshold: 3,
        });
    }
};
